import 'moment/locale/pl';
import 'moment/locale/en-gb';
import moment from "moment";

export default moment.locale(localStorage.getItem('i18nextLng'));